<template>
  <div class="tableau-view" v-resize="onResize" />
</template>

<script>
import "tableau-api";
import { Debouncer, tryParse } from '../../libraries/common';
export default {
  props: ['modelData', 'filterName', 'availableFilters', 'availableParameters'],
  data() {
    return {
      undoLoader: false,
      resetFiltersLoader: false,
      viz: null,
      debouncer: new Debouncer(100),
      currentFilters: tryParse(localStorage.getItem(this.filterName)) || {},
    };
  },
  methods: {
    initViz() {
      const container = this.$el;
      const options = {
        ...this.currentFilters,
        onFirstVizSizeKnown: () => {
          // Once the viz is rendered, set the height of the viz container so
          // that the footer displays in the correct place.
          // This uses the minSize property of the viz, which is not actually
          // the rendered height of the iframe. For now, hardcode an offset to
          // account for this. Ultimately, Tableau needs to give us a better way
          // to get the true viz height.*
          container.style.height = `${viz.getVizSize().sheetSize.minSize.height}px`;
        },
      }
      const url = `${this.modelData.serverUrl}/trusted/${this.modelData.ticket}/t/${this.modelData.site}/views/${this.modelData.worksheet}/${this.modelData.view}?:toolbar=no&:tabs=no&:showShareOptions=false&:showVizHome=no&:subscriptions=no&:showAppBanner=false&:embed=yes&:dataDetails=no`;
      // const url = "https://public.tableau.com/views/VacationHome/VacationHome?:embed=y&:display_count=yes";
      var tableau = window.tableau;
      const viz = new tableau.Viz(container, url, options);
      viz.addEventListener(tableau.TableauEventName.FILTER_CHANGE, this.onFilterSelection);
      viz.addEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE, this.onParameterSelection);
      viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, () => window.scrollTo(0, 0));
      this.viz = viz;
    },
    onFilterSelection(data) {
      this.debouncer.push(() => new Promise(resolve => {
        data.getFilterAsync()
          .then(filter => {
            console.log('onFilterSelection', filter.getFieldName());
            if (this.availableFilters.includes(filter.getFieldName())) {
              var appliedValues = filter.getAppliedValues().map(f => f.value);
              if (appliedValues[0] != null) {
                this.currentFilters[filter.getFieldName()] = appliedValues;
              }
            }
            resolve();
          });
      }))
        .onFinishFnc(this.saveFiltersToLocalStorage);
    },
    onParameterSelection(data) {
      this.debouncer.push(() => new Promise(resolve => {
        data.getParameterAsync()
          .then(parameter => {
            console.log('onParameterSelection', parameter.getName());
            if (this.availableParameters[parameter.getName()]) {
              this.currentFilters[parameter.getName()] = this.availableParameters[parameter.getName()](parameter.getCurrentValue());
            }
            resolve();
          });
      }))
        .onFinishFnc(this.saveFiltersToLocalStorage);
    },
    undoAction() {
      this.undoLoader = true
      this.viz.undoAsync().always(() => this.undoLoader = false)
    },
    resetFilters() {
      this.resetFiltersLoader = true
      this.viz.getWorkbook().revertAllAsync()
        .always(() => {
          this.resetFiltersLoader = false;
          this.currentFilters = {};
          this.saveFiltersToLocalStorage();
        });
    },
    saveFiltersToLocalStorage() {
      localStorage.setItem(this.filterName, JSON.stringify(this.currentFilters));
    },
    onResize() {
      const width = this.$el.clientWidth;
      const height = this.$el.clientHeight;
      this.viz?.setFrameSize(width, height);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisTableauView'] = this;
    this.initViz();
  },
}
</script>

<style lang="scss" scoped>
.tableau-view {
  width: 100%;
  height: 801px;
}
</style>